import { render } from "./PaypalPaymentForStory.vue?vue&type=template&id=132b3683"
import script from "./PaypalPaymentForStory.vue?vue&type=script&lang=js"
export * from "./PaypalPaymentForStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__